import React from "react";

const XCircleIcon = ({ className = "" }) => {
  return (
    <div
      className={`relative inline-flex items-center justify-center w-6 h-6 rounded-full border-2 border-current ${className}`}
    >
      <span className="absolute block w-4 h-0.5 bg-current transform rotate-45" />
      <span className="absolute block w-4 h-0.5 bg-current transform -rotate-45" />
    </div>
  );
};

export default XCircleIcon;
